// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.job-request-search-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 1.25rem;
}
.job-request-search-page .page-title {
  margin: 0 0 1rem;
  font-size: 1.25rem;
  font-weight: 600;
}
.job-request-search-page .page-content {
  min-height: 120px;
}
.job-request-search-page .search-form {
  padding: 1rem;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
.job-request-search-page .filter-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 12px;
}
.job-request-search-page .field,
.job-request-search-page .field-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
}
.job-request-search-page .field > span,
.job-request-search-page .field-group > span {
  font-size: 12px;
  font-weight: 600;
}
.job-request-search-page .field-wide {
  grid-column: span 2;
}
.job-request-search-page .test-type-select {
  min-height: 72px;
}
.job-request-search-page .range-fields {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}
.job-request-search-page .form-actions {
  display: flex;
  gap: 8px;
  margin-top: 14px;
}
.job-request-search-page .form-actions button {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.job-request-search-page .loading-state,
.job-request-search-page .empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  min-height: 100px;
  color: #666;
}
.job-request-search-page .results-loading {
  min-height: 180px;
}
.job-request-search-page .results-section {
  overflow: hidden;
  padding: 0.75rem;
  background: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
}
.job-request-search-page .results-header {
  margin-bottom: 0.25rem;
}
.job-request-search-page .results-count {
  color: #6c757d;
  font-size: 0.875rem;
}
.job-request-search-page .empty-state {
  padding: 2rem;
  color: #6c757d;
  text-align: center;
  background: #f8f9fa;
  border: 1px dashed #dee2e6;
  border-radius: 4px;
}
.job-request-search-page .empty-state p {
  margin: 0;
}
.job-request-search-page .results-table {
  margin-bottom: 0;
  font-size: 0.8125rem;
}
.job-request-search-page .results-table thead th {
  white-space: nowrap;
  font-weight: 600;
  background: #f8f9fa;
}
.job-request-search-page .results-table tbody td {
  background: #fff;
}
.job-request-search-page .results-table tbody tr:nth-of-type(even) td {
  background: #fcfcfd;
}
.job-request-search-page .request-link {
  color: #005a9c;
  font-weight: 600;
  text-decoration: underline;
}
.job-request-search-page mat-paginator {
  margin-top: 4px;
}
.job-request-search-page .error-message {
  margin-top: 12px;
  padding: 8px 12px;
  border-left: 4px solid #c62828;
  border-radius: 4px;
  background-color: #ffebee;
  color: #c62828;
  font-size: 13px;
}
@media (max-width: 900px) {
  .job-request-search-page .filter-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
@media (max-width: 560px) {
  .job-request-search-page .filter-grid {
    grid-template-columns: 1fr;
  }
  .job-request-search-page .field-wide {
    grid-column: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/pages/tools/job-request-search/job-request-search.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,cAAA;EACA,gBAAA;AACF;AACE;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;AACJ;AAEE;EACE,iBAAA;AAAJ;AAGE;EACE,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AADJ;AAIE;EACE,aAAA;EACA,gDAAA;EACA,SAAA;AAFJ;AAKE;;EAEE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,YAAA;AAHJ;AAKI;;EACE,eAAA;EACA,gBAAA;AAFN;AAME;EACE,mBAAA;AAJJ;AAOE;EACE,gBAAA;AALJ;AAQE;EACE,aAAA;EACA,8BAAA;EACA,QAAA;AANJ;AASE;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AAPJ;AASI;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;AAPN;AAWE;;EAEE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;EACA,WAAA;AATJ;AAYE;EACE,iBAAA;AAVJ;AAaE;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AAXJ;AAcE;EACE,sBAAA;AAZJ;AAeE;EACE,cAAA;EACA,mBAAA;AAbJ;AAgBE;EACE,aAAA;EACA,cAAA;EACA,kBAAA;EACA,mBAAA;EACA,0BAAA;EACA,kBAAA;AAdJ;AAgBI;EACE,SAAA;AAdN;AAkBE;EACE,gBAAA;EACA,oBAAA;AAhBJ;AAkBI;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;AAhBN;AAmBI;EACE,gBAAA;AAjBN;AAoBI;EACE,mBAAA;AAlBN;AAsBE;EACE,cAAA;EACA,gBAAA;EACA,0BAAA;AApBJ;AAuBE;EACE,eAAA;AArBJ;AAwBE;EACE,gBAAA;EACA,iBAAA;EACA,8BAAA;EACA,kBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;AAtBJ;AAyBE;EACE;IACE,gDAAA;EAvBJ;AACF;AA0BE;EACE;IACE,0BAAA;EAxBJ;EA2BE;IACE,iBAAA;EAzBJ;AACF","sourcesContent":[".job-request-search-page {\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 1.25rem;\n\n  .page-title {\n    margin: 0 0 1rem;\n    font-size: 1.25rem;\n    font-weight: 600;\n  }\n\n  .page-content {\n    min-height: 120px;\n  }\n\n  .search-form {\n    padding: 1rem;\n    background: #fff;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n  }\n\n  .filter-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    gap: 12px;\n  }\n\n  .field,\n  .field-group {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 0;\n\n    > span {\n      font-size: 12px;\n      font-weight: 600;\n    }\n  }\n\n  .field-wide {\n    grid-column: span 2;\n  }\n\n  .test-type-select {\n    min-height: 72px;\n  }\n\n  .range-fields {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 6px;\n  }\n\n  .form-actions {\n    display: flex;\n    gap: 8px;\n    margin-top: 14px;\n\n    button {\n      display: inline-flex;\n      align-items: center;\n      gap: 8px;\n    }\n  }\n\n  .loading-state,\n  .empty-state {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    min-height: 100px;\n    color: #666;\n  }\n\n  .results-loading {\n    min-height: 180px;\n  }\n\n  .results-section {\n    overflow: hidden;\n    padding: 0.75rem;\n    background: #fff;\n    border: 1px solid #dee2e6;\n    border-radius: 4px;\n  }\n\n  .results-header {\n    margin-bottom: 0.25rem;\n  }\n\n  .results-count {\n    color: #6c757d;\n    font-size: 0.875rem;\n  }\n\n  .empty-state {\n    padding: 2rem;\n    color: #6c757d;\n    text-align: center;\n    background: #f8f9fa;\n    border: 1px dashed #dee2e6;\n    border-radius: 4px;\n\n    p {\n      margin: 0;\n    }\n  }\n\n  .results-table {\n    margin-bottom: 0;\n    font-size: 0.8125rem;\n\n    thead th {\n      white-space: nowrap;\n      font-weight: 600;\n      background: #f8f9fa;\n    }\n\n    tbody td {\n      background: #fff;\n    }\n\n    tbody tr:nth-of-type(even) td {\n      background: #fcfcfd;\n    }\n  }\n\n  .request-link {\n    color: #005a9c;\n    font-weight: 600;\n    text-decoration: underline;\n  }\n\n  mat-paginator {\n    margin-top: 4px;\n  }\n\n  .error-message {\n    margin-top: 12px;\n    padding: 8px 12px;\n    border-left: 4px solid #c62828;\n    border-radius: 4px;\n    background-color: #ffebee;\n    color: #c62828;\n    font-size: 13px;\n  }\n\n  @media (max-width: 900px) {\n    .filter-grid {\n      grid-template-columns: repeat(2, minmax(0, 1fr));\n    }\n  }\n\n  @media (max-width: 560px) {\n    .filter-grid {\n      grid-template-columns: 1fr;\n    }\n\n    .field-wide {\n      grid-column: auto;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
